import {
  SET_RECENTLY_BLOCKED,
  SET_RECENTLY_UNBLOCKED,
  SET_RECENTLY_DELETED
} from '@actions/types';

const INITIAL_STATE = {
  recentlyBlockedId: null,
  recentlyUnblockedId: null,
  recentlyDeletedId: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_RECENTLY_BLOCKED:
      return { ...state, recentlyBlockedId: action.payload, recentlyUnblockedId: null };
    case SET_RECENTLY_UNBLOCKED:
      return { ...state, recentlyUnblockedId: action.payload, recentlyBlockedId: null };
    case SET_RECENTLY_DELETED:
      return { ...state, recentlyDeletedId: action.payload };
    default:
      return state;
  }
};
